import { render, staticRenderFns } from "./searchCOC.vue?vue&type=template&id=4b0f9cee&scoped=true&"
import script from "./searchCOC.vue?vue&type=script&lang=js&"
export * from "./searchCOC.vue?vue&type=script&lang=js&"
import style0 from "./searchCOC.vue?vue&type=style&index=0&id=4b0f9cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f9cee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
